const e = {
  name: "Windmill",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,0h-7v11.1c-2,0.3-3.8,1.4-5,3v-2H0v7h10.1L6,34.9V40h24v-5.1L27.2,24H36v-7H25.3l-0.1-0.4l0,0
			c-0.4-1.6-1.4-3-2.7-4c-0.3-0.2-0.5-0.4-0.8-0.6H24V0z M23.3,17h-2.4c-0.3-0.9-1-1.5-1.8-1.8v-2.1c0.9,0.2,1.7,0.5,2.3,1.1
			C22.3,14.8,22.9,15.8,23.3,17z M20.8,19h3l0.2,0.8V24h1.1L28,35.1V38H8v-2.9L12.2,19h3c0.3,0.9,1,1.5,1.8,1.8V24h-5v12h7V20.8
			C19.9,20.5,20.5,19.9,20.8,19z M26,19h8v3h-8V19z M19,18c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1c0-0.5,0.5-1,1-1C18.5,17,19,17.5,19,18
			z M12.7,17c0.6-2,2.2-3.5,4.3-3.9v2.1c-0.9,0.3-1.5,1-1.8,1.8H12.7z M2,17v-3h8v3H2z M19,10V2h3v8H19z M14,26h3v8h-3V26z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Windmill
};
